import React from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getUserManager } from "../util/userManager";

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user
    }
  }

  componentWillMount() {
    if (window.location.href.indexOf("id_token") > 0) {
      // console.log(window.location.href);
    } else {
      // console.log("Redirect url")
      getUserManager().signinRedirect();
    }
  }

  render() {
    return (
      <div />
    );
  }
}

const mapStateToProps = (state) => {
  return {
  }
}
export default withRouter(connect(mapStateToProps)(LoginPage));
